import cookie from '@/app/js/helpers/cookie'

export function getAdmitadQueries() {
  if (cookie.getCookie('admitad_click_id') && cookie.getCookie('last_paid_source') === 'admitad') {
    return {
      admitad_uid: cookie.getCookie('admitad_click_id'),
      utm_source: 'admitad&utm_medium=cpa',
    }
  }

  return {}
}
